import ProductFilters from './ProductFilters';

const els = document.querySelectorAll('.js-product-filters');

for (let el of els) {
    new ProductFilters(el);
}
